module.exports = __webpack_public_path__ + "static/media/main_visual_skid_steer_loaders_1650_r_manitou.30cd1466.png";